<template>
    <div class="my-collection-container">
      <!-- <div class="custom-header">
        
          <h1>My Collections</h1>
        
      </div> -->
      <el-main >
        <div class="tabs-header" >
          <el-tabs v-model="activeTab" class="demo-tabs" @tab-click="handleTabClick" >
            <!-- v-if="['Pro', 'Supreme'].includes(creator_functionality_level) -->
            <el-tab-pane label="Acquired Bundles" name="bundles">
              <div class="posts-container">
                <div class="tab-header">
                  <div class="view-mode-selector">
                    <el-radio-group v-model="viewMode" size="small">
                      <el-radio-button label="list">
                        <i class="el-icon-menu"></i>
                      </el-radio-button>
                      <el-radio-button label="grid">
                        <i class="el-icon-s-grid"></i>
                      </el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <el-skeleton :rows="3" animated v-if="bundlesLoading"/>
                <template v-else>
                  <div v-if="viewMode === 'list'" class="list-container">
                    <BundleSimple
                      v-for="bundle in bundles"
                      :key="bundle._id?.$oid || bundle._id?.$id || bundle.id"
                      :bundle="bundle || {}"
                      @click.native="handleBundleClick(bundle)"
                    />
                  </div>
                  <div v-else class="grid-container">
                    <BundleSimple
                      v-for="bundle in bundles"
                      :key="bundle._id?.$oid || bundle._id?.$id || bundle.id"
                      :bundle="bundle || {}"
                      @click.native="handleBundleClick(bundle)"
                    />
                  </div>
                  <div v-if="bundles.length === 0" class="empty-state">
                    <p>You haven't acquired any Knowit Bundle yet.</p>
                    <!-- <el-button type="primary" @click="$router.push('/new-bundle')">
                      Get Your First Knowit Bundle
                    </el-button> -->
                  </div>
                </template>
              </div>
            </el-tab-pane>

            <el-tab-pane label="Acquired Decks" name="purchased" >
              <div class="posts-container">
                <div class="tab-header">
                  <div class="view-mode-selector">
                    <el-radio-group v-model="viewMode" size="small">
                      <el-radio-button label="list">
                        <i class="el-icon-menu"></i>
                      </el-radio-button>
                      <el-radio-button label="grid">
                        <i class="el-icon-s-grid"></i>
                      </el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <el-skeleton :rows="3" animated v-if="purchasedLoading"/>
                <template v-else >
                  <template v-if="viewMode === 'list'">
                    <Collection
                      v-for="collection in purchasedPosts"
                      :key="collection._id && (collection._id.$oid || collection._id.$id) ? (collection._id.$oid || collection._id.$id) : collection.id || collection._id || Math.random()"
                      :collection="collection"
                      :hideStats="true"
                      @showOrderSettings="handleShowOrderSettings(collection)"
                      @like="handleLike"
                    />
                  </template>
                  <div v-else class="grid-container">
                    <CollectionSimpleCard
                      v-for="collection in purchasedPosts"
                      :key="collection._id && (collection._id.$oid || collection._id.$id) ? (collection._id.$oid || collection._id.$id) : collection.id || collection._id || Math.random()"
                      :collection="collection"
                      @showOrderSettings="handleShowOrderSettings(collection)"
                      @click="goToCollection((collection._id && (collection._id.$oid || collection._id.$id)) ? (collection._id.$oid || collection._id.$id) : (collection.id || ''))"
                    />
                  </div>
                  <div v-if="purchasedPosts.length === 0" class="empty-state">
                    <p>You haven't acquired any Course yet.</p>
                    <!-- <el-button type="primary" @click="$router.push('/square')">
                      Visit Square
                    </el-button> -->
                  </div>
                </template>
              </div>
            </el-tab-pane>

            <el-tab-pane label="Acquired Stacks" name="acquired">
              <div class="posts-container">
                <el-skeleton :rows="3" animated v-if="acquiredLoading"/>
                <template v-else>
                  <div class="grid-container">
                    <Post
                      v-for="post in acquiredPosts"
                      :key="post.id"
                      :post="post || {}"
                      @like="handleLike"
                      @comment="handleComment"
                    />
                  </div>
                  <div v-if="acquiredPosts.length === 0" class="empty-state">
                    <p>You haven't acquired any Knowit yet.</p>
                    <!-- <el-button type="primary" @click="$router.push('/square')">
                      Visit Square
                    </el-button> -->
                  </div>
                </template>
              </div>
            </el-tab-pane>

            <el-tab-pane label="Subscribed Contents" name="subscriptions">
              
              
            </el-tab-pane>

            <!-- Hidden: Acquired Knowit Cards tab -->
            <!-- <el-tab-pane label="Acquired Knowit Cards" name="acquired_cards">
              <div class="posts-container">
                <el-skeleton :rows="3" animated v-if="acquiredCardsLoading" style="padding: 20px;" />
                <div v-else>
                  <div v-if="acquiredCards.length === 0" class="empty-state">
                    <p>You haven't received any shared Knowit cards yet.</p>
                    <p style="font-size: 14px; color: #909399; margin-top: 10px;">
                      Cards shared with you by other users will appear here.
                    </p>
                  </div>
                  
                  <div v-else class="acquired-cards-container">
                    <div class="cards-grid">
                      <SimpleCardView 
                        v-for="card in acquiredCards" 
                        :key="card.id" 
                        :card="card"
                        :is-in-context-pot="isCardInContextPot(card)"
                        :can-share="false"
                        @click="viewAcquiredCard"
                        @add-to-context="addToContextPot"
                        class="card-item" 
                      />
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane> -->
            
            
          </el-tabs>
        </div>
      </el-main>

      <!-- Order Settings Dialog -->
      <el-dialog
        title="Order & Settings"
        :visible.sync="orderSettingsDialogVisible"
        width="60%"
        :before-close="() => orderSettingsDialogVisible = false"
      >
        <div class="order-info-container" v-if="selectedCollection && selectedCollection.order_info">
          <div class="info-section">
            <h4>Order Details</h4>
            <div class="info-row">
              <span class="label">Order ID:</span>
              <span class="value">{{ selectedCollection.order_info._id?.$oid || selectedCollection.order_info._id?.$id || 'N/A' }}</span>
            </div>
            <div class="info-row">
              <span class="label">Order Date:</span>
              <span class="value">{{ selectedCollection.order_info.create_time ? new Date(selectedCollection.order_info.create_time * 1000).toLocaleDateString() : 'N/A' }}</span>
            </div>
            <div class="info-row">
              <span class="label">Price Paid:</span>
              <span class="value">${{ selectedCollection.order_info.usd_price || '0.00' }}</span>
            </div>
          </div>
          <el-button type="primary" size="small" @click="downloadInvoice(selectedCollection)">Receipt</el-button>
        </div>
      </el-dialog>

      <Receipt ref="receipt"></Receipt>
    </div>
  </template>
  
  <script>
  import Post from '@/components/Post.vue'
  import Collection from '@/components/Collection.vue'
  import CollectionSimpleCard from '@/components/CollectionSimpleCard.vue'
  import BundleSimple from '@/components/BundleSimple.vue'
  import KnowitCardList from '@/components/KnowitCardList.vue'
  import SimpleCardView from '@/components/SimpleCardView.vue'
  import { postRequest } from '@/apis/front'
  import { preloadImages } from '@/utils/imageCache'
  import Receipt from './receipt.vue'

  export default {
    name: 'MyAcquisitions',
    components: {
      Collection,
      CollectionSimpleCard,
      BundleSimple,
      Post,
      KnowitCardList,
      SimpleCardView,
      Receipt
    },
    data() {
      return {
        creator_functionality_level: this.$store.state.user_info.creator_functionality_level,
        activeTab: localStorage.getItem('myAcquisitionsTab') || 'acquired',
        acquiredPosts:[],
        purchasedPosts: [],
        acquiredCards: [],
        acquiredCardsLoading: false,
        acquiredLoading: false,

        purchasedLoading: false,
        createdLoading: false,
        viewMode: localStorage.getItem('collectionViewMode') || 'list',
        bundles: [],
        bundlesLoading: false,
        orderSettingsDialogVisible: false,
        selectedCollection: null,
        // Track which tabs have been loaded
        loadedTabs: {
          acquired: false,
          purchased: false,
          bundles: false,
          cards: false
        }
      }
    },
    watch: {
      viewMode(newMode) {
        localStorage.setItem('collectionViewMode', newMode)
      }
    },
    mounted() {
      this.$nextTick(() => {  // Ensure DOM is updated
        // Only load data for the active tab on mount
        this.loadTabData(this.activeTab);
      })
    },
    methods: {
      loadTabData(tabName) {
        // Only load if not already loaded
        if (this.loadedTabs[tabName]) return;

        switch(tabName) {
          case 'acquired':
            this.fetchAcquiredPosts();
            this.loadedTabs.acquired = true;
            break;
          case 'purchased':
            this.fetchPurchasedPosts();
            this.loadedTabs.purchased = true;
            break;
          case 'bundles':
            this.fetchBundles();
            this.loadedTabs.bundles = true;
            break;
          case 'cards':
            this.fetchAcquiredCards();
            this.loadedTabs.cards = true;
            break;
        }
      },
      handleTabClick(tab) {
        this.activeTab = tab.paneName
        localStorage.setItem('myAcquisitionsTab', tab.paneName)
        // Load data for the clicked tab
        this.loadTabData(tab.paneName)
      },
      async fetchPurchasedPosts() {
        this.purchasedLoading = true
        try {
          const response = await postRequest('getMyPurchasedPostCollections', {
            user_id: this.$store.state.user_id,
          })

          if (response.data.code === 0) {
            this.purchasedPosts = response.data.data
            this.purchasedLoading = false

            // Preload cover images in the background for faster subsequent views
            const coverUrls = this.purchasedPosts
              .map(collection => collection.cover_url)
              .filter(Boolean)
            if (coverUrls.length > 0) {
              preloadImages(coverUrls)
            }
          } else {
            this.$message.error(response.data.msg || 'Failed to fetch purchased posts')
          }
        } catch (error) {
          console.error('Error fetching purchased posts:', error)
          this.$message.error('Failed to fetch purchased posts')
        } finally {
          this.purchasedLoading = false
        }
      },
      
      
      handleLike(postId) {
        console.log('Like post:', postId)
      },
      handleComment(postId) {
        console.log('Comment on post:', postId)
      },
      handleNewCollection() {
        localStorage.setItem('editCollectionId', '')
        this.$router.push('/new-collection')
      },
      async fetchBundles() {
        this.bundlesLoading = true
        try {
          const response = await postRequest('getAcquiredBundles', {
            user_id: this.$store.state.user_id,
          })
          
          if (response.data.code === 0) {
            this.bundles = response.data.data
          } else {
            this.$message.error(response.data.msg || 'Failed to fetch bundles')
          }
        } catch (error) {
          console.error('Error fetching bundles:', error)
          this.$message.error('Failed to fetch bundles')
        } finally {
          this.bundlesLoading = false
        }
      },
      handleNewBundle() {
        localStorage.setItem('editBundleId', '')
        this.$router.push('/new-bundle')
      },
      handleBundleClick(bundle) {
        console.log('bundle:', bundle)
        this.$store.dispatch('setTempBundleId', bundle._id?.$oid || bundle._id?.$id || bundle.id)
        this.$router.push('/bundle')
      },
      fetchAcquiredPosts() {
        this.acquiredLoading = true
        const params = {
          user_id: this.$store.state.user_id
        }

        postRequest('getAcquiredPosts', params).then(response => {
          if (response.data.code === 0) {
            this.acquiredPosts = response.data.data
          } else {
            this.$message.error(response.msg || 'Failed to fetch acquired posts')
          }
        }).catch(error => {
          console.error('Error fetching acquired posts:', error)
          this.$message.error('Failed to fetch acquired posts')
        }).finally(() => {
          this.acquiredLoading = false
        })
      },
      handleShowOrderSettings(collection) {
        this.selectedCollection = collection
        this.orderSettingsDialogVisible = true
      },

       downloadInvoice(row){
            this.orderSettingsDialogVisible = false
            this.$refs.receipt.open(row)
        },
      goToCollection(collectionId) {
        this.$store.dispatch('setTempCollectionId', collectionId)
        this.$router.push({ path: '/read-collection', query: { source: 'acquisitions' } })
      },

      // Acquired Cards methods
      async fetchAcquiredCards() {
        this.acquiredCardsLoading = true
        
        try {
          const response = await postRequest('getAcquiredCards', {
            user_id: this.$store.state.user_id
          })

          if (response.data.code === 0) {
            let cards = response.data.data || []
            
            // Transform acquired cards data to match the expected format
            this.acquiredCards = cards.map(card => {
              // Ensure all required fields are present
              return {
                ...card,
                id: card.id || (card._id ? ((card._id.$oid || card._id.$id) || card._id) : ''),
                title: card.title || 'Untitled Card',
                content: card.content || '',
                content_type: card.content_type || 'text',
                created_at: card.created_at || card.acquired_at || Date.now() / 1000,
                labels: card.labels || [],
                fileList: card.fileList || [],
                // Add acquired-specific info
                original_owner_name: card.original_owner_name,
                acquired_at: card.acquired_at,
                share_message: card.share_message,
                is_acquired: true
              }
            })
          } else {
            console.error('Failed to fetch acquired cards:', response.data.msg)
            this.$message.error(response.data.msg || 'Failed to fetch acquired cards')
          }
        } catch (error) {
          console.error('Error fetching acquired cards:', error)
          this.$message.error('Failed to load acquired cards')
        } finally {
          this.acquiredCardsLoading = false
        }
      },

      viewAcquiredCard(card) {
        // Handle card view logic if needed
        console.log('Viewing acquired card:', card)
      },

      async saveAcquiredCard(cardData) {
        // For acquired cards, we might not allow editing, just viewing
        this.$message.warning('You can only view acquired cards, not edit them')
      },

      async deleteAcquiredCard(card) {
        // For acquired cards, we might not allow deletion
        this.$message.warning('You cannot delete acquired cards')
      },

      // Context pot methods
      addToContextPot(item) {
        this.$store.dispatch('contextPot/toggleItem', item).then(result => {
          if (result.success) {
            if (result.action === 'added') {
              this.$message.success('Added to context pot');
            } else {
              this.$message.info('Removed from context pot');
            }
          }
        });
      },

      isCardInContextPot(card) {
        return this.globalContextPot.some(potItem => potItem.id === card.id);
      }
    },

    computed: {
      globalContextPot() {
        return this.$store.state.contextPot?.items || [];
      }
    }
  }
  </script>
  
  <style scoped>
  .my-collection-container {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-width: 0;
  }
  
  .custom-header {
    background-color: #409EFF;
    color: white;
    padding-left: 20px;
    width: 100%;
    height: 64px;
    flex-shrink: 0;
  }
  
  .el-main {
    padding: 20px;
    width: 100%;
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    min-width: 0;
  }
  
  .posts-container {
    
    width: 80%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 20px 0;
    flex: 1;
    overflow-y: auto;
    height: calc(100vh - 150px); /* This forces the container to respect flex sizing */
  }
  
  .empty-state {
    text-align: center;
    padding: 40px;
    color: #909399;
  }
  
  .empty-state p {
    margin-bottom: 20px;
  }
  
  .tabs-header {
    flex-shrink: 0;
  }
  
  .section-title {
    margin: 0;
    white-space: nowrap;
  }
  
  .demo-tabs {
    background: white;
    width: 100%;
  }
  
  .el-tabs__content {
    width: 100%;
  }
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1400px;
    margin: 0 auto;
    padding: 10px 20px; /* Reduced padding from 20px to 10px vertical */
    height: 100%;
  }
  
  .tab-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-right: 20px;
  }
  
  .view-mode-selector {
    margin-left: auto;
    margin-right: 20px;
  }

  .list-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 20px;
  }

  .grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    gap: 16px;
    padding: 20px;
  }

  .order-info-container {
    padding: 20px;
  }

  .info-section {
    background: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
  }

  .info-row {
    display: flex;
    margin: 10px 0;
    color: #606266;
  }

  .label {
    font-weight: 500;
    width: 150px;
    color: #909399;
  }

  .value {
    flex: 1;
  }

  .setting-item {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 15px 0;
    border-bottom: 1px solid #ebeef5;
  }

  .setting-item:last-child {
    border-bottom: none;
  }

  .setting-label {
    flex: 1;
    font-size: 14px;
    color: #606266;
  }

  h4 {
    margin: 0 0 15px 0;
    color: #303133;
  }

  /* Acquired Cards Styles */
  .acquired-cards-container {
    width: 100%;
    height: 100%;
  }

  .acquired-cards-container .cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
    padding: 20px;
    width: 100%;
  }

  .acquired-cards-container .card-item {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .acquired-cards-container .card-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  /* Responsive adjustments for acquired cards */
  @media (max-width: 1200px) {
    .acquired-cards-container .cards-grid {
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: 16px;
      padding: 16px;
    }
  }

  @media (max-width: 768px) {
    .acquired-cards-container .cards-grid {
      grid-template-columns: 1fr;
      gap: 12px;
      padding: 12px;
    }
  }

  </style>